import { render, staticRenderFns } from "./OwnerInformationTab.vue?vue&type=template&id=56b9cb38"
import script from "./OwnerInformationTab.vue?vue&type=script&lang=js"
export * from "./OwnerInformationTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports